export default __webpack_public_path__ + "static/media/slide2.b2f9eb03.png";